<template>
  <!-- Supplies the bubble the attachment branch does not have, and flattens the inner card
       so a nested quote does not paint a card inside a card. The class list below must stay
       exactly the real bubble's — the styles live outside this component. -->
  <div class="card customer-chat border-0 mw-100 mr-2 v2026-qm-host">
    <div class="card-body">
      <QuotedMessageV2026 :quotedMessage="quotedMessage" />
      <!-- Slot content compiles in the PARENT's scope, so it keeps the parent's styles. -->
      <slot />
    </div>
  </div>
</template>

<script>
import QuotedMessageV2026 from './QuotedMessageV2026'

export default {
  name: 'QuoteBubbleHostV2026',
  components: {
    QuotedMessageV2026
  },
  props: {
    quotedMessage: {
      type: Object,
      default: null
    }
  }
}
</script>

<style scoped>
.v2026-qm-host ::v-deep .card {
  background: transparent !important;
  border: 0 !important;
  border-radius: 0 !important;
  box-shadow: none !important;

  padding: 0 !important;
}

.v2026-qm-host ::v-deep .card > .card-body {
  padding: 0 !important;
}
</style>
